// import { Button } from '@jutro/legacy/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useEffect, useCallback, useState } from 'react';
// import messages from './TurnOnAutopayComponent.messages';
import metadata from './TurnOnAutopayComponent.metadata.json5';
import styles from './TurnOnAutopayComponent.module.scss';

function TurnOnAutopayComponent(props) {
    const PAY_PLAN_1OPAY = 'payment_plan:11';
 
    const { payFrom, bindData, paymentPlan, setAutoPay, enableEdit} = props;
    const [isPayPlan10Pay, setIsPayPlan10Pay] = useState(false);
    const [autopayReadonly, setAutopayReadonly] = useState(false);
    const [autoPay, updateAutpPay] = useState();

    useEffect(() => {
        if (bindData && bindData.paymentPlans) {
            const plans = bindData.paymentPlans;
            const current = plans.find(plan => plan.billingId === paymentPlan);
            
            setAutopayReadonly(current.autoDraftPlan_TWIA);
            setAutoPay(current.autoDraftPlan_TWIA || bindData?.customerPaymentDetails_TWIA?.isAutoPayEnabled);
            updateAutpPay(current.autoDraftPlan_TWIA || bindData?.customerPaymentDetails_TWIA?.isAutoPayEnabled);

            // 2025-01-21 - Debra Frum - US25425 - CE - Offer Edit - 10 Pay
            setIsPayPlan10Pay(paymentPlan === PAY_PLAN_1OPAY);
        }
    }, [paymentPlan]);

    const onAutopayEnabledChange = useCallback(
        value => {
            setAutoPay(value);
            updateAutpPay(value);
        },
    [setAutoPay]);

    const overrideProps = {
        autopayEnabled: {
            readOnly:  autopayReadonly || enableEdit,
            value: autoPay
        },
        // 2025-01-21 - Debra Frum - US25425 - CE - Offer Edit - 10 Pay
        // Display "auto pay is required" message when 10 Pay Payment Plan is selected on an offer
        autoPayRequiredMessage: {
            visible: (payFrom === "offers") && isPayPlan10Pay
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onAutopayEnabledChange
        }
    };

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

export default TurnOnAutopayComponent;
